import { render, staticRenderFns } from "./TranslationsView.vue?vue&type=template&id=767fd37f&scoped=true"
import script from "./TranslationsView.vue?vue&type=script&lang=js"
export * from "./TranslationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "767fd37f",
  null
  
)

export default component.exports